/**
 * Danish CVR format used on Indstillinger › Generelt.
 * A CVR is exactly eight digits. The field is optional, so a blank value is valid.
 * Surrounding spaces are ignored. Letters, separators, and any other length are not.
 */
const CVR_DIGITS = /^\d{8}$/;

export function isValidCvr(value: string | null | undefined): boolean {
  if (value == null) return true;
  const trimmed = value.trim();
  if (trimmed.length === 0) return true;
  return CVR_DIGITS.test(trimmed);
}
